function createTaskFn(form) {
    const durationField = form.querySelector('select[name="duration"]');
    const label = form.querySelector('label[for="id_duration"]');
    const typeField = document.getElementById('intentusPomodoroType').textContent;

    const calcMinutes = (durationValue, typeFieldValue) => {
        let minutes = 25;
        let breakMin = 5;
        if (typeFieldValue === 'type2') {
            minutes = 50;
            breakMin = 10;
        }
        return parseInt(durationValue) * minutes + (parseInt(durationValue) - 1) * breakMin;
    }

    const updateMinutes = () => {
        const minutesSpan = form.querySelector('#durationMinutes');
        if (minutesSpan && typeField) {
            const minutes = calcMinutes(durationField.value, typeField);
            minutesSpan.textContent = ` (${minutes} minutes)`;
        }
    }

    if (label && !label.textContent.includes("(minutes)")) {
        if (typeField) {
            const minutes = calcMinutes(durationField.value, typeField);
            const span = document.createElement('span');
            span.setAttribute('id', 'durationMinutes');
            span.textContent = ` (${minutes} minutes)`;
            label.appendChild(span);
        }
    }

    // Update the displayed minutes when the duration changes
    durationField.addEventListener('change', updateMinutes);

}